import script from "./IOrderEventItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IOrderEventItem.vue?vue&type=script&setup=true&lang=js"

import "./IOrderEventItem.vue?vue&type=style&index=0&id=58cb8e91&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58cb8e91"]])

export default __exports__